import React, { useState, useEffect } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

function VendorRegisterDevice() {
    const [deviceUuid, setDeviceUuid] = useState("");
    const [enrollmentCode, setEnrollmentCode] = useState("");
    const [deviceName, setDeviceName] = useState("");
    const [location, setLocation] = useState("");
    const [message, setMessage] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [showQR, setShowQR] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        const role = localStorage.getItem("role");
        if (!token || role !== "vendor") {
            navigate("/");
        }
    }, [navigate]);

    const handleClaim = async (e) => {
        e.preventDefault();
        setMessage("");
        setSubmitting(true);
        try {
            // vendor_id is intentionally not sent: the server takes ownership
            // from the authenticated token, so the client cannot claim a
            // device on another vendor's behalf.
            const res = await fetch(`${API_BASE_URL}/api/vendor/devices/claim`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    device_uuid: deviceUuid.trim(),
                    enrollment_code: enrollmentCode.trim().toUpperCase(),
                    name: deviceName || "unnamed",
                    location: location || undefined,
                }),
            });
            const data = await res.json();
            setMessage(data.message || "Unexpected response");
            if (res.ok) {
                setDeviceUuid("");
                setEnrollmentCode("");
                setDeviceName("");
                setLocation("");
            }
        } catch (err) {
            setMessage(`Could not reach the server: ${err.message}`);
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        let scanner;
        if (showQR) {
            scanner = new Html5QrcodeScanner("qr-reader", { fps: 10, qrbox: 250 }, false);
            scanner.render(
                (decodedText) => {
                    try {
                        const data = JSON.parse(decodedText);
                        setDeviceUuid(data.device_uuid || "");
                        setEnrollmentCode(data.enrollment_code || "");
                    } catch {
                        setMessage("That QR code is not a WallBurst pairing code.");
                    }
                    setShowQR(false);
                    scanner.clear();
                },
                () => {
                    // Per-frame decode misses are normal while aiming the
                    // camera; surfacing them as errors made the UI unusable.
                }
            );
        }
        return () => {
            if (scanner) scanner.clear().catch(() => {});
        };
    }, [showQR]);

    return (
        <div style={{ maxWidth: 480, margin: "2rem auto", padding: "1rem", background: "#f9f9f9", borderRadius: "8px" }}>
            <h3>Register New Device</h3>
            <p style={{ fontSize: "0.9rem", color: "#555" }}>
                Power on the screen and scan the pairing code it displays. Codes
                expire shortly after they appear and can only be used once.
            </p>
            <form onSubmit={handleClaim} style={{ display: "grid", gap: "0.5rem", marginBottom: "1rem" }}>
                <input
                    type="text"
                    placeholder="Device name"
                    value={deviceName}
                    onChange={(e) => setDeviceName(e.target.value)}
                    style={{ padding: "0.5rem" }}
                />
                <input
                    type="text"
                    placeholder="Address / location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    style={{ padding: "0.5rem" }}
                />
                <input
                    type="text"
                    placeholder="Device ID (from screen)"
                    value={deviceUuid}
                    onChange={(e) => setDeviceUuid(e.target.value)}
                    required
                    style={{ padding: "0.5rem" }}
                />
                <input
                    type="text"
                    placeholder="Pairing code"
                    value={enrollmentCode}
                    onChange={(e) => setEnrollmentCode(e.target.value.toUpperCase())}
                    required
                    style={{ padding: "0.5rem", textTransform: "uppercase" }}
                />
                <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button type="button" onClick={() => setShowQR(true)}>
                        Scan QR
                    </button>
                    <button type="submit" disabled={submitting} style={{ padding: "0.5rem 1rem" }}>
                        {submitting ? "Registering…" : "Register Device"}
                    </button>
                </div>
            </form>
            {showQR && (
                <div style={{ marginBottom: "1rem" }}>
                    <div id="qr-reader" style={{ width: "100%" }} />
                    <button onClick={() => setShowQR(false)}>Cancel</button>
                </div>
            )}
            {message && <div style={{ color: "#4f8cff" }}>{message}</div>}
        </div>
    );
}

export default VendorRegisterDevice;
